<footer class="bg-gray-900 text-white py-10 mt-20">
  <div class="max-w-6xl mx-auto px-6 text-center">
    <div class="text-lg font-semibold mb-4">AuditFixers</div>

    <p class="text-gray-400 text-sm">
      Independent ISO 27001 and ISO 42001 compliance services built for clarity, speed, and fairness.
    </p>

    <div class="mt-6 text-gray-500 text-xs">© 2026 AuditFixers. All rights reserved.</div>
  </div>
</footer>
